import o from "./index853.js";
import e from "./index854.js";
import t from "./index855.js";
import m from "./index856.js";
function s(r) {
  return t(r) ? o(m(r)) : e(r);
}
export {
  s as default
};
